import { ServiceConfig } from 'angular-odata';

//#region ODataApi Imports
//#endregion

export const ArtikelbezeichnungsgeneratorServiceConfig = {
  name: "Artikelbezeichnungsgenerator",
  annotations: []
} as ServiceConfig;